// extracted by mini-css-extract-plugin
export default {"UpdateKeyGiver":"UpdateKeyGiver_UpdateKeyGiver__9OZnV","form":"UpdateKeyGiver_form__n1RHI"};